import React from 'react';
import { Box, costFormater, Hint, HintText, Preloader, Text } from '@common-fe/common-fe';

import BannerItem from '../../BannerItem';
import { BannerCurrentInvoiceProps } from '../BannerReplenishmentPreview.types';

import { StyledDimmedText } from './BannerReplenishmentPreview.styles';

export const BannerCurrentInvoice: React.FC<BannerCurrentInvoiceProps> = ({ value, isLoading }) => (
  <Box
    data-testid="dashboard_banner_replenishment-preview_current-invoice"
    direction="column"
    justify="start"
    align="start"
    gap="spacing8"
    pad={{ vertical: 'spacing16' }}
    style={{ flex: 1 }}
  >
    {isLoading ? (
      <Box
        data-testid="dashboard_banner_replenishment-preview_current-invoice_loader"
        align="center"
        justify="center"
      >
        <Preloader />
      </Box>
    ) : (
      <>
        <BannerItem.Title
          data-testid="dashboard_banner_replenishment-preview_current-invoice_amount"
          weight={700}
          size="2xl"
          style={{ lineHeight: 1 }}
        >
          {costFormater(value, { isOptionalPrecision: true })}
        </BannerItem.Title>

        <Hint
          hintWidth={240}
          hintHeight={100}
          hintElement={
            <Box margin={{ top: 'spacing4' }}>
              <HintText>
                <StyledDimmedText
                  data-testid="dashboard_banner_replenishment-preview_current-invoice_title"
                  color="textOnColor"
                  size="medium"
                  weight={400}
                >
                  Current Invoice Accrual
                </StyledDimmedText>
              </HintText>
            </Box>
          }
        >
          <Text
            data-testid="dashboard_banner_replenishment-preview_current-invoice_hint"
            textAlign="center"
            size="small"
          >
            Claim spend will continue to accrue against this invoice until the next invoice date
          </Text>
        </Hint>
      </>
    )}
  </Box>
);

export default BannerCurrentInvoice;
